import { Component } from '@angular/core';

@Component({
  selector: 'lib-shared',
  imports: [],
  templateUrl: './shared.html',
  styleUrl: './shared.css',
})
export class Shared {}
